/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, bool, shape, number, string, arrayOf,
} from 'prop-types';
import { connect } from 'react-redux';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import Business from '../../../assets/svg/Business';
import Apo from '../../../assets/svg/Apo';
import School from '../../../assets/svg/School';
import Church from '../../../assets/svg/Church';
import FuneralHome from '../../../assets/svg/FuneralHome';
import PoBox from '../../../assets/svg/PoBox';
import Hospital from '../../../assets/svg/Hospital';
import Residence from '../../../assets/svg/HomeSolid';

class DesktopAddress extends React.Component {
    loadList = (recipient) => {
        const { handleDesktopSingleAdrressGetClicked } = this.props;
        handleDesktopSingleAdrressGetClicked(recipient);
    };

    loadIcon = (value) => {
        switch (value) {
            case 'Business':
                return <Business className="svgIcon" />;
            case 'School':
                return <School className="svgIcon" />;
            case 'Church':
                return <Church className="svgIcon" />;
            case 'Funeral home':
                return <FuneralHome className="svgIcon" />;
            case 'P.O.Box':
                return <PoBox className="svgIcon" />;
            case 'Hospital':
                return <Hospital className="svgIcon" />;
            case 'Residence':
                return <Residence className="svgIcon" />;
            case 'Apartment':
                return <Residence className="svgIcon" />;
            default:
                return <Apo className="svgIcon" />;
        }
    }

    render() {
        const { recipient, isSelected } = this.props;
        const Addresses = recipient?.Addresses;
        const recipientAddresses = Addresses?.filter((a) => a.AddressType !== 'Billing');
        return (
            recipientAddresses?.map((address) => (
                <div
                    key={address?.AddressId}
                    aria-hidden
                    onClick={() => this.loadList(recipient)}
                    role="link"
                    className={`addressListItem ${isSelected ? 'selected' : ''}`}
                >
                    <span className="listRecipient">{recipient?.FirstName} {recipient?.LastName}, { address?.City}</span> {this.loadIcon(address?.AddressType)}
                </div>
            ))
        );
    }
}
DesktopAddress.defaultProps = {
    recipient: {},
    isSelected: false,
    handleDesktopSingleAdrressGetClicked: () => {},
};

DesktopAddress.propTypes = {
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        FirstName: string,
        LastName: string,
        RelationShip: string,
        NickName: string,
        EmailAddress: string,
        LastUpdateDate: string,
        NumberOfAddresses: number,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                ContactId: number,
            }),
        ),
    }),
    isSelected: bool,
    handleDesktopSingleAdrressGetClicked: func,
};
const mapDispatchToProps = (dispatch) => ({
    handleDesktopSingleAdrressGetClicked: (recipient) => dispatch(EventDispatcher.handleDesktopSingleAdrressGetClicked(recipient)),
});

export default connect(
    null,
    mapDispatchToProps,
)(DesktopAddress);
